import React from "react";
import { useIntl } from "react-intl";

import Seo from "../../../../common/helpers/seo";

import Hero from "./Hero";
import Why from "./Why/Why";
import Features from "./Features";

import messages from "./messages";
import { StyledHome } from "./styles";

const dev = process.env.NODE_ENV === "development";

const Home = () => {
    const { formatMessage } = useIntl();
    return (
        <StyledHome marginTop={50} withShadow>
            <Seo
                title={`Musicators - ${formatMessage(messages.slogen)}`}
                description={formatMessage(messages.description)}
                app="memory"
            />
            <Hero />
            <Why />
            <Features />
        </StyledHome>
    );
};

export default Home;
